//@flow
export const overtimeCellWidth = 38;
export const userCellWidth = 200;
export const shiftCellWidth = 136 //143;
export const shiftCellHeight = 48;


export const popOptionsWidth = 142;
export const popOptionsHeight = 81;

export const weekDays = ['mo', 'tu', 'we', 'th', 'fr', 'sa', 'su']
export const weekDaysGerman = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So']

export const beginningOfTime = '200001'

export const weeksInYear_DE = {
  '2015': 53,
  '2016': 52,
  '2017': 52,
  '2018': 52,
  '2019': 52,
  '2020': 53,
  '2021': 52,
  '2022': 53,
  '2023': 53,
  '2024': 52,
  '2025': 52,
  '2026': 53,
  '2027': 52,
}



// WEBPACK FOOTER //
// ./src/constants/roster.js